"use client";
import useCenterIdOpenPages from "@portal/hooks/useCenterIdOpenPages";
import LayoutNotAuthorized from ".";
import { ILayout } from "./types";

const LayoutNotAuthorizedClientWrapper = ({ children }: React.PropsWithChildren<ILayout>) => {
  const centerId = useCenterIdOpenPages();
  return <LayoutNotAuthorized centerId={centerId}>{children}</LayoutNotAuthorized>;
};

export default LayoutNotAuthorizedClientWrapper;
